import {
    ADD_SADAD_FAILED, ADD_SADAD_LOADING, ADD_SADAD_REMOVE, ADD_SADAD_SUCCESS
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
    sadadConfig: null,
    request: null,
};

export const sadadConfigReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any, request: any }
) => {
    switch (action.type) {
        case ADD_SADAD_LOADING:
            return {
                ...state,
                loading: true,
            };
        case ADD_SADAD_SUCCESS:
            return {
                ...state,
                loading: false,
                sadadConfig: action.payload,
                status: action.status,
                error: null,
                request: action.request
            };
        case ADD_SADAD_FAILED:
            return {
                ...state,
                loading: false,
                status: action.status,
                error: action.error,
                request: action.request

            };
        case ADD_SADAD_REMOVE:
            return initialState

        default:
            return state;
    }
};




